import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useGlobalContext } from "../GlobalContext";

const Perkiraan = () => {
  const { api, isReady } = useGlobalContext();
  const [dataPerkiraan, setDataPerkiraan] = useState([]);
  const [form, setForm] = useState({
    id: null,
    kdperk: "",
    keterangan: "",
    posisi: "",
    penbia: "",
  });
  const [modalAddOpen, setModalAddOpen] = useState(false);
  const [modalEditOpen, setModalEditOpen] = useState(false);
  const [searchText, setSearchText] = useState("");

  const getData = async () => {
    const response = await api.get("/api/akuntansi");
    const hasil = Array.isArray(response.data) ? response.data : [];
    setDataPerkiraan(hasil);
  };

  useEffect(() => {
    if (isReady) {
      getData();
    }
  }, [isReady]);

  const handleInputChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    const payload = {
      kdperk: form.kdperk,
      keterangan: form.keterangan,
      posisi: form.posisi,
      penbia: form.penbia,
    };
    await api.post("/api/akuntansi/perkiraan", payload);
    setModalAddOpen(false);
    getData();
  };

  const handleEdit = (item) => {
    setForm(item);
    setModalEditOpen(true);
  };

  const handleUpdate = async () => {
    try {
      const payload = {
        keterangan: form.keterangan,
        posisi: form.posisi,
        penbia: form.penbia,
      };
      await api.patch(`/api/akuntansi/perkiraan/${form.kdperk}`, payload);
      setModalEditOpen(false);
      getData();
    } catch (err) {
      console.error("Gagal update data:", err.message);
      alert("Gagal update data");
    }
  };

  const handleDelete = async (kdperk) => {
    if (window.confirm("Yakin hapus data ini?")) {
      try {
        await api.delete(`/api/akuntansi/perkiraan/${kdperk}`);
        getData();
      } catch (err) {
        alert("Gagal menghapus data: " + err.message);
      }
    }
  };

  const columns = [
    {
      name: "No",
      selector: (row, index) => index + 1,
      width: "60px",
      center: true,
    },
    {
      name: "Kode",
      selector: (row) => row.kdperk,
      sortable: true,
      center: true,
    },
    {
      name: "Keterangan",
      selector: (row) => row.keterangan,
      sortable: true,
    },
    {
      name: "Posisi",
      selector: (row) => (row.posisi === "D" ? "DEBET" : "KREDIT"),
      center: true,
      width: "100px",
    },
    {
      name: "Kelompok",
      selector: (row) => (row.penbia === true || row.penbia === "true" ? "RUGI LABA" : "NERACA"),
      center: true,
      width: "120px",
    },
    {
      name: "Aksi",
      cell: (row) => (
        <div className="d-flex gap-2 justify-content-center">
          <button className="btn btn-info btn-sm" onClick={() => handleEdit(row)}>
            <i className="fa fa-edit" />
          </button>
          <button className="btn btn-danger btn-sm" onClick={() => handleDelete(row.kdperk)}>
            <i className="fa fa-trash" />
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "150px",
      center: true,
    },
  ];

  const filteredData = dataPerkiraan.filter(
    (item) =>
      item.kdperk.toLowerCase().includes(searchText.toLowerCase()) ||
      item.keterangan.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div className="card shadow-sm">
    <div className="card-header d-flex justify-content-end">
  <button
    className="btn btn-primary btn-sm"
    style={{ fontSize: "14px", padding: "6px 14px" }}
    onClick={() => {
      setForm({ id: null, kdperk: "", keterangan: "", posisi: "", penbia: "" });
      setModalAddOpen(true);
    }}
  >
    Tambah Data
  </button>
</div>

      <div className="card-body">
        <div className="mb-2 d-flex justify-content-end">
          <input
            type="text"
            className="form-control form-control-sm"
            style={{ maxWidth: "200px" }}
            placeholder="Cari kode/keterangan..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          striped
          dense
          highlightOnHover
          responsive
          customStyles={{
            headCells: {
              style: {
                fontWeight: 'bold',
                fontSize: '16px',
                backgroundColor: '#f0f0f0',
                padding: '10px 12px',
                borderRight: '2px solid #ddd',
              },
            },
            cells: {
              style: {
                borderRight: '1px solid #ddd',
                padding: '12px 10px',
              },
            },
            rows: {
              style: {
                borderBottom: '1px solid #eee',
              },
            },
          }}
          className="table table-bordered"
        />
      </div>

      {/* Modal Tambah */}
      {modalAddOpen && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-md" role="document">
            <div className="modal-content shadow">
              <div className="modal-header">
                <h5 className="modal-title">TAMBAH PERKIRAAN</h5>
                <button type="button" className="btn-close" onClick={() => setModalAddOpen(false)}></button>
              </div>
              <div className="modal-body">
                {["kdperk", "keterangan"].map((field, i) => (
                  <div key={i} className="form-group mb-2">
                    <label>{field.toUpperCase()}</label>
                    <input
                      type="text"
                      name={field}
                      className="form-control"
                      value={form[field]}
                      onChange={handleInputChange}
                    />
                  </div>
                ))}
                <div className="form-group mb-2">
                  <label>Posisi</label>
                  <select className="form-control" name="posisi" value={form.posisi} onChange={handleInputChange}>
                    <option value="">-- Pilih Posisi --</option>
                    <option value="D">DEBET</option>
                    <option value="K">KREDIT</option>
                  </select>
                </div>
                <div className="form-group mb-2">
                  <label>Kelompok</label>
                  <select className="form-control" name="penbia" value={form.penbia} onChange={handleInputChange}>
                    <option value="">-- Pilih Kelompok --</option>
                    <option value="false">NERACA</option>
                    <option value="true">RUGI LABA</option>
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary btn-sm" onClick={() => setModalAddOpen(false)}>Batal</button>
                <button className="btn btn-success btn-sm" onClick={handleSubmit}>Simpan</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Edit */}
      {modalEditOpen && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-md" role="document">
            <div className="modal-content shadow">
              <div className="modal-header">
                <h5 className="modal-title">EDIT PERKIRAAN</h5>
                <button type="button" className="btn-close" onClick={() => setModalEditOpen(false)}></button>
              </div>
              <div className="modal-body">
                <div className="form-group mb-2">
                  <label>KODE</label>
                  <input disabled className="form-control" name="kdperk" value={form.kdperk} />
                </div>
                <div className="form-group mb-2">
                  <label>KETERANGAN</label>
                  <input
                    className="form-control"
                    name="keterangan"
                    value={form.keterangan}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group mb-2">
                  <label>POSISI</label>
                  <select className="form-control" name="posisi" value={form.posisi} onChange={handleInputChange}>
                    <option value="">-- Pilih Posisi --</option>
                    <option value="D">DEBET</option>
                    <option value="K">KREDIT</option>
                  </select>
                </div>
                <div className="form-group mb-2">
                  <label>KELOMPOK</label>
                  <select className="form-control" name="penbia" value={form.penbia} onChange={handleInputChange}>
                    <option value="">-- Pilih Kelompok --</option>
                    <option value="false">NERACA</option>
                    <option value="true">RUGI LABA</option>
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary btn-sm" onClick={() => setModalEditOpen(false)}>Batal</button>
                <button className="btn btn-success btn-sm" onClick={handleUpdate}>Simpan</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Perkiraan;